import LandingRightSide from './LandingRightSide';

export default LandingRightSide;
